import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ "checkBox" ];
  connect() {
  }

  selectAll() {
    const elements = this.checkBoxTargets;
    elements.forEach( element => element.checked = true )
  }

  deSelectAll() {
    const elements = this.checkBoxTargets;
    elements.forEach( element => element.checked = false )
  }

  selectNeverSignedIn() {
    const elements = this.checkBoxTargets;
    elements.forEach( element => {
      element.checked = element.dataset.neverSignedIn === 'true'
    })
  }

  selectNeverStudied() {
    const elements = this.checkBoxTargets;
    elements.forEach( element => {
      element.checked = element.dataset.neverStudied === 'true'
    })
  }

  selectCurrentStudents() {
    const elements = this.checkBoxTargets;
    elements.forEach( element => {
      element.checked = element.dataset.currentStudent === 'true'
    })
  }
}
